import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import homePageReducer from './homePageReducer';
import pricingReducer from './pricingReducer';
import accountDetails from './accountDetailsReducer';
import authentication from './loginReducer';
import paymentDetail from './paymentDetailReducer';
import vehicles from './vehiclesReducer';
import * as ActionTypes from '../constants/actionTypes';

const appReducer = combineReducers({
 
  routing: routerReducer,
  locationDetail:homePageReducer,
  pricing:pricingReducer,
  accountDetails,
  authentication,
  paymentDetail,
  vehicles,
  form: formReducer
});


const rootReducer = (state, action) => {
  if (action.type === ActionTypes.RESET) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js